<!-- 详情页搜索组件 -->
<template>
  <div class="c-detail-search">
    <CityCascader class="search-city"/>
    <div class="search-content">
      <input class="search-input" type="text" placeholder="请输入搜索内容">
      <button class="search-btn">搜索</button>
    </div>
  </div>
</template>

<script>
import CityCascader from '@/components/common/MyCascader/city'

export default {
    data () {
        return {}
    },
    components: {
        CityCascader
    }
}
</script>

<style scoped>
.c-detail-search {
  width: 7.23rem;
  margin: 0 auto;
}
.search-city, .search-content {
    display: inline-block;
    vertical-align: top;
}
.search-content {
  margin-left: 6px;
}
.search-input {
    padding: .08rem .12rem;
    box-sizing: border-box;
    display: inline-block;
    width: 4.25rem;
    height:40px;
    line-height: 40px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(234,234,234,1);
    vertical-align: top;
}
.search-btn {
    width:92px;
    height:40px;
    line-height: 40px;
    background:rgba(38,127,242,1);
    color: #fff;
    vertical-align: top;
}

body.h5Style .search-input {
    width: 2.03rem;
    font-size: 14px;
}
body.h5Style .search-city, body.h5Style .search-content {
        vertical-align: text-bottom;
    }
    body.h5Style .c-detail-search {
      text-align: center;
    }
</style>
